import React from "react";
import { View } from "react-native";
import { TouchableOpacity, Text, Image } from "react-native";
import styles from "../styles";
import theme from "../theme";
import { IS_DESKTOP } from "../helpers";

const PMButton = ({ title, onPress, inverse = false, disabled = false, image = null }) => {
	return (
		<View style={IS_DESKTOP ? { flex: 1, flexDirection: "row" } : {}}>
			<TouchableOpacity
				style={[
					styles.form.button,
					{
						backgroundColor: inverse ? "transparent" : theme.colors.orange,
					},
					IS_DESKTOP ? { width: "300px" } : {},
				]}
				onPress={onPress}
				disabled={disabled}
			>
				<Text style={[styles.text.button, { color: inverse ? theme.colors.orange : theme.colors.white }]}>
					{inverse ? title : title.toUpperCase()}
				</Text>
				{image && <Image source={image} style={styles.form.buttonImage} />}
			</TouchableOpacity>
		</View>
	);
};

export default PMButton;
